"use client";

import React, { useEffect, useState } from "react";
import Mascot1 from "@/components/promotion/MascotV1";
import Mascot3 from "@/components/promotion/MascotV2";
import MascotSanta from "@/components/promotion/MascotSanta";
import { getMascot } from "@/services/promotion-api";
import { Mascot as MascotType } from "@/types/promotion";
import { useToast } from "@/context/ToastContext";

const Mascot: React.FC = () => {
  const { showError } = useToast();
  const [mascot, setMascot] = useState<MascotType>(MascotType.mascot_1);

  useEffect(() => {
    const fetchMascot = async () => {
      try {
        const data = await getMascot();
        setMascot(data?.mascot ?? MascotType.mascot_1);
      } catch (e: any) {
        console.error("Error fetching mascot:", e);
        showError?.(e?.message || "Failed to load mascot");
        setMascot(MascotType.mascot_1);
      }
    };

    fetchMascot();
  }, []); 

  // Render the correct mascot
  switch (mascot) {
    case MascotType.mascot_2:
      return <Mascot3 />;

    case MascotType.mascot_3:
      return <MascotSanta />;

    case MascotType.mascot_1:
    default:
      return <Mascot1 />;
  }
};

export default Mascot;
